import React, { useState, createContext } from 'react';

export const UnreadContext = createContext();

export const UnreadProvider = ({ children }) => {
  const [messagesCount, setMessagesCount] = useState(0);
  const [notificationsCount, setNotificationsCount] = useState(0);

  const value = {
    messagesCount,
    setMessagesCount,
    notificationsCount,
    setNotificationsCount,
  };

  return <UnreadContext.Provider value={value}>{children}</UnreadContext.Provider>;
};
